export const LOGIN = "/Login";
export const DASHBOARD = "/";
// export const DASHBOARD = "/Dashboard";
export const DETAILS_VIEW = "/DetailsView";
export const ABOUT_US = "/AboutUs";
export const DONATE_SECURITY = "/CollabSecurity";
export const TRANSPARENCY = "/Transparency";
export const IMPACT_ATHELETE_JOURNEY = "/ImpactAthleteJourney";
export const NIL_COMPLIANCE_AND_PROCEDURES = "/NILComplianceAndProcedures";
export const ADDRESSING_NIL_INEQUALITY = "/AddressingNILInequality";
export const BUILDING_TRUST_IN_NIL = "/BuildingTrustInNIL";
export const NIL_SUPPORT_SERVICES_AND_FEES = "NILSupportServices";
export const ACCOUNT_INFORMATION = "/AccountInformation";
export const CHANGE_PASSWORD = "/ChangePassword";
export const DELETE_SCREEN = "/DeleteScreen";
export const ADMIN_DASHBOARD = "/AdminDashboard";
export const CREATE_USER = "/CreateUser";
export const CONTACT_US = "/contactus";
export const FAVORITES = "/favorites";
export const PAYMENT_SUCCESS = "/success";
export const PAYMENT_FAILED = "/failed";
export const PRIVACY_POLICY="/PrivacyPolicy";
export const CREATE_ATHLETE_PROFILE = "/CreateAthleteProfile";